import { render, staticRenderFns } from "./workMaterial.vue?vue&type=template&id=f0350a90&scoped=true&"
import script from "./workMaterial.vue?vue&type=script&lang=js&"
export * from "./workMaterial.vue?vue&type=script&lang=js&"
import style0 from "./workMaterial.vue?vue&type=style&index=0&id=f0350a90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0350a90",
  null
  
)

export default component.exports